import { useContext, useEffect, useReducer, useRef, useState } from "react";
import { AuthContext } from "../AuthContext";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from "react-router-dom";
import { deleteDoc, doc } from "firebase/firestore";
import db, {storage } from "../firebase";
import TextShortener from "../TextShortener";
import { DisplayUserPicAndName, formatMediaTime, FormatTimePassedUtc, getMediaStoragePath, reverseMediaTimeToSeconds } from "../newComponents/GeneralClasses";
import { HbrAvatarProfile, HbrBrushIcon, HbrDeleteIcon, HbrFlagReport, HbrIconFileCopy, HbrReplyIcon, HbrShareIcon } from "../newComponents/Mycustomsvgicons";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { deleteObject, ref as mediaStorageRef} from "firebase/storage";
import TextShortenerWithoutButton from "../newComponents2/TextShortener3";
import { ChatContext } from "../newComponents2/ChatContextApi";
import ChatAudioPlayer from "../newComponents2/ChatAudioPlayer";
import WiderImageView from "../newComponents2/WiderImageView";
import UseLayout from "../newComponents/useLayout";



const Message = ({messages,message,userEmail,chatImage,timestamp,displayName,messageID,audioUrl,web_audio_duration,usercode,replyTo,messageRepliedTo,chatImageRepliedTo}) => {
    const [menuoptions,setMenuoptions]=useState(false);
    const [showMenu,setShowMenu]=useState(false);
    const [owner,setOwner]=useState(false);
    const [state,dispatch]=useReducer(reducer,{progressIndicator: false, openImageView: false, userNameToDisplay: "", userProfilePic: ""});
    const [audioDuration,setAudioDuration]=useState("");
    const [webAudioDuration,setWebAudioDuration]=useState(null);
    const navigate = useNavigate();
    const messageRef = useRef();
    const menuRef = useRef();
    const audioRef = useRef(null);
    const {user_email} = useContext(AuthContext);
    const {userName} = useContext(AuthContext);
    const {handleReply} = useContext(ChatContext);
    const {width} = UseLayout();
    

    useEffect(()=>{
        if(userEmail === user_email){
            setOwner(true);
        }else{
            setOwner(false);
        }

        async function getUserInfo() {
            const userInfo = await DisplayUserPicAndName(userEmail);
            if (userInfo) {
                const nameFromDB = userInfo.name && userInfo.name !== "" ? userInfo.name : displayName;
                dispatch({type: actionConsts.USER_NAME_DISPLAY, payload: nameFromDB});
                dispatch({type: actionConsts.USER_PICTURE, payload: userInfo.profilePic});
            };
        }
        getUserInfo();
    },[userEmail, displayName, user_email]);

    useEffect(()=>{
        const closeMenu=(e)=>{
            if(!menuRef.current.contains(e.target)){
                setMenuoptions(false);
            }
        }
        document.addEventListener('mousedown',closeMenu);
        return ()=>{
            document.removeEventListener('mousedown',closeMenu);
        }
    },[]);

    const deleteChatDoc=async()=>{
        setMenuoptions(false);
        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
        try{
            if (chatImage && chatImage !== "") {
                const imagePath = mediaStorageRef(storage, `${getMediaStoragePath(chatImage)}`);
                await deleteObject(imagePath);
            }

            if (audioUrl && audioUrl !== "") {
                const audioPath = mediaStorageRef(storage, `${getMediaStoragePath(audioUrl)}`);
                await deleteObject(audioPath);
            }

            if(messageID !== null){
                const doc_Ref = doc(db,"CHAT3",messageID);
                await deleteDoc(doc_Ref);
            }
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
        }catch{
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
        }
    };

    const report=()=>{
        navigate("/contact");
    };

    const onReplyClicked=()=>{
        if (audioUrl && audioRef.current) {
            const duration = audioRef.current.duration;
        setAudioDuration(formatMediaTime(duration));
        if (formatMediaTime(duration) === "Infinity NaN:NaN") {
            handleReply(true,state.userNameToDisplay, `🎵 Audio ${web_audio_duration}`, chatImage, web_audio_duration);
        }else{
            handleReply(true,state.userNameToDisplay, `🎵 Audio ${audioDuration}`, chatImage, audioDuration);
        }
   
        }else{
            handleReply(true,state.userNameToDisplay, message, chatImage, "");
        }
        setMenuoptions(false);
    };

    useEffect(()=>{
      const timeid =  setTimeout(() => {
            if (audioUrl && web_audio_duration) {
                const durationInSeconds = reverseMediaTimeToSeconds(web_audio_duration);
                setWebAudioDuration(durationInSeconds);
             }else{
                if (audioRef.current) {
                    setWebAudioDuration(audioRef.current.duration);
                }
             }
        }, 2000);
        return clearImmediate(timeid);
    },[web_audio_duration, audioUrl]);

    useEffect(() => {
    if (messageRef.current) {
        messageRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest" // or "center"
          });
    }
    },[message]);

    const handleCloseImageView=()=>{
        dispatch({type: actionConsts.OPEN_IMAGE_VIEW});
      };
  
      const handleViewImage=(imageToView)=>{
        if (imageToView) {
            dispatch({type: actionConsts.IMAGE_URL, payload: imageToView});
            dispatch({type: actionConsts.OPEN_IMAGE_VIEW});
        }
      };
  
   
    return ( 
        <div ref={messageRef} className = {`message ${userEmail === user_email && "owner"}`}>
            <div className="messageInfo">
                
                {state.userProfilePic !== null && state.userProfilePic !== "" ? 
                (<img src={state.userProfilePic} alt="" onClick={()=>handleViewImage(state.userProfilePic)}/>)
                    :
                ( <HbrAvatarProfile width={"1.8em"} height={"1.8em"} />)
                }
            </div>

            <div className="messageContent"
                onMouseEnter={()=>setShowMenu(true)} onMouseLeave={()=>setShowMenu(false)}>

                <div className="mctop" ref={menuRef}>
                    {state.userNameToDisplay === userName ?
                     (<span style={{color:"black", fontWeight:"bold"}}>You</span>) 
                     :
                     (<span style={{color:"black"}}>{state.userNameToDisplay}</span>)
                    }

                   <HbrReplyIcon width={"1.7em"} height={"1.7em"} fillColour={"black"} handleClick={()=>onReplyClicked()}/>

                    <div className="mcmenu" style={{position:"relative"}}>
                        {showMenu &&
                            (
                                <div style={{cursor:"pointer"}}
                                    onClick={()=>setMenuoptions(prev => !prev)}>
                                    <MoreVertIcon/>
                                </div>
                            )
                        }
                       
                        {menuoptions && 
                            <div className="mcmenuoption">
                                {owner && 
                                    <div className="flex-row2">
                                      <HbrDeleteIcon width={"1.5em"} height={"1.5em"} fillColour={"#000000"}/>
  
                                      <button onClick={()=>deleteChatDoc()} 
                                      style={{backgroundColor:"transparent",border:"none",fontWeight:"bold"}}>
                                          Delete
                                      </button>
                                  
                                  </div>
                                }

                                {!owner && 
                                    <div className="flex-row2">
                                        <HbrFlagReport width={"1.5em"} height={"1.5em"} fillColour={"#000000"}/>

                                        <button onClick={() => report()} 
                                        style={{color:"red",backgroundColor:"transparent",border:"none", fontWeight:"bold"}}>
                                            Report
                                        </button>

                                    </div>
                                }

                                <div className="flex-row2">
                                    <HbrReplyIcon width={"1.5em"} height={"1.5em"} fillColour={"#000000"}/>

                                    <button onClick={() => onReplyClicked()} 
                                    style={{backgroundColor:"transparent",border:"none", fontWeight:"bold"}}>
                                        Reply
                                    </button>
                                </div>

                                <div className="flex-row2">
                                    <HbrShareIcon width={"1.5em"} height={"1.5em"} fillColour={"#000000"}/>

                                    <button onClick={() => report()} 
                                    style={{backgroundColor:"transparent",border:"none", fontWeight:"bold"}}>
                                        Share
                                    </button>

                                </div>

                                <div className="flex-row2">
                                    <HbrIconFileCopy width={"1.5em"} height={"1.5em"} fillColour={"#000000"}/>
                                    
                                    <button onClick={() => report()} 
                                    style={{backgroundColor:"transparent",border:"none", fontWeight:"bold"}}>
                                        Copy
                                    </button>

                                </div>

                            </div>
                        }
                    </div>
                </div>

                {replyTo && 
                    (
                        <div className="repliedmsg flex-row2" style={{height:"fit-content", maxWidth:"90%", gap:"10px", backgroundColor:"white"}}>
                            <div style={{backgroundColor:"#eb268f",width:"2px",height:"100%"}}></div>
                            <div className="repliedbodyview flex-column2" style={{gap:"5px"}}>
                                <p style={{fontWeight:"bold"}}>{replyTo}</p>
                                <TextShortenerWithoutButton fullText={messageRepliedTo} words={50} />
                            </div>
                            {chatImageRepliedTo && <img style={{width:"3em"}} src={chatImageRepliedTo} alt="" />}
        
                        </div>
                    )
                }

                {chatImage && (<img src={chatImage} alt="" onClick={()=>handleViewImage(chatImage)}/>)}

                {message && (
                    <div  style={{width:"100%"}}>
                          <TextShortener fullText={message} words={width <= 500 ? 150 : 400} />
                          <br/>
                    </div>
                )}

                {timestamp && 
                    (
                    <div style={{position:"absolute",right:"2px",bottom:"0px"}}>
                        <span style={{color:`${audioUrl ? '#ffffff':'#1a1a1a'}`, fontSize:"12px"}}>
                            {FormatTimePassedUtc(timestamp)}
                        </span>
                    </div>
                    )
                }

                {audioUrl && 
                    (
                        <div style={{backgroundColor:"#282828"}}>
                            <audio src={audioUrl} ref={audioRef} style={{display:"none"}}/>
                            <ChatAudioPlayer
                                audioUrl={audioUrl}
                                mediaDuration={webAudioDuration && webAudioDuration}
                            />
                            <br/>   
                        </div> 
                    )
                }
            
          
            </div>

            {state.progressIndicator && 
                <div style={{
                    position:"absolute",
                    top:"50%",
                    left:"45%",
                    border: "5px solid black",
                    borderBottom: "5px solid white",
                    borderTop: "5px solid white",
                    borderRadius: "50%",
                    animation: "spin2 2s linear infinite",
                    backgroundColor: "#00000050"
                    }}>
                          <HbrBrushIcon width="2em" height="2em" fillColour="#ffffff"/>
                </div>
            }

            {state.openImageView && 
            <div>
                  <WiderImageView imageUrl={state.imageUrl} handleCloseView={handleCloseImageView}/>
            </div>
            }
        </div>
     );
}
export default Message;